import React from 'react'

export default ({name, fieldName, title, onChange, data = [], value = 0, isDisabled, isLoading, className = '', isError}) => {
    const field = fieldName || {value:'value', text:'text'};
    return (  
        <select
            id={name}
            name={name} 
            onChange={onChange} 
            disabled={isDisabled || isLoading}
            className={`form-control textbox-kc${(isError) ? ' textbox-kc-error' : ''} ${className}`} value={value}>
                <option hidden disabled value='0'>{(isLoading) ? 'Loading...' : `-- ${title} --`}</option>
                {data.map((datax, index) =><option key={index} value={datax[field.value]}>{datax[field.text]}</option> )}
        </select> 
    );
}